import React from "react";
import { motion } from "framer-motion";

// Custom Coal -> Steam -> Useful -> Products energy-flow Sankey (SVG).
export function SankeyFlow({ data }) {
  if (!data) return null;
  const W = 760, H = 320;

  // Node columns
  const col = { coal: 40, steam: 250, useful: 470, prod: 690 };
  const scale = (pct) => (pct / 100) * (H - 40);

  // helper to build a smooth flow band between two vertical segments
  const band = (x0, y0a, y0b, x1, y1a, y1b, color, op = 0.5) => {
    const mx = (x0 + x1) / 2;
    return (
      <path
        d={`M ${x0} ${y0a} C ${mx} ${y0a} ${mx} ${y1a} ${x1} ${y1a}
            L ${x1} ${y1b} C ${mx} ${y1b} ${mx} ${y0b} ${x0} ${y0b} Z`}
        fill={color} opacity={op} />
    );
  };

  const coalH = scale(100);
  const steamH = scale(data.steam);
  const usefulH = scale(data.useful);
  const megH = scale(data.meg), degH = scale(data.deg), tegH = scale(data.teg);

  const topPad = 20;
  // y positions (top-aligned)
  const coalY = topPad;
  const steamY = topPad;
  const usefulY = topPad;
  const nodeW = 14;

  const Node = ({ x, y, h, color, label, pct }) => (
    <g>
      <rect x={x} y={y} width={nodeW} height={h} fill={color} />
      <text x={x + nodeW + 8} y={y + 14} fill="#fff" fontSize="12" fontFamily="Chivo" fontWeight="700">{label}</text>
      <text x={x + nodeW + 8} y={y + 30} fill={color} fontSize="13" fontFamily="JetBrains Mono" fontWeight="600">{pct}%</text>
    </g>
  );

  return (
    <div className="w-full overflow-x-auto" data-testid="sankey-flow">
      <motion.svg viewBox={`0 0 ${W} ${H}`} className="w-full min-w-[640px]"
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6 }}>
        {/* Coal -> Steam (+ boiler loss) */}
        {band(col.coal + nodeW, coalY, coalY + steamH, col.steam, steamY, steamY + steamH, "#fab20b", 0.45)}
        {/* boiler loss diverges */}
        {band(col.coal + nodeW, coalY + steamH, coalY + coalH, col.steam, steamY + steamH + 6, steamY + coalH, "#E63946", 0.22)}
        {/* Steam -> Useful */}
        {band(col.steam + nodeW, steamY, steamY + usefulH, col.useful, usefulY, usefulY + usefulH, "#33b76d", 0.4)}
        {/* distribution loss */}
        {band(col.steam + nodeW, steamY + usefulH, steamY + steamH, col.useful, usefulY + usefulH + 6, usefulY + steamH, "#E63946", 0.18)}
        {/* Useful -> products */}
        {band(col.useful + nodeW, usefulY, usefulY + megH, col.prod, topPad, topPad + megH, "#33b76d", 0.5)}
        {band(col.useful + nodeW, usefulY + megH, usefulY + megH + degH, col.prod, topPad + megH + 10, topPad + megH + 10 + degH, "#1d6fb8", 0.5)}
        {band(col.useful + nodeW, usefulY + megH + degH, usefulY + megH + degH + tegH, col.prod, topPad + megH + degH + 20, topPad + megH + degH + 20 + tegH, "#9b5de5", 0.5)}

        <Node x={col.coal} y={coalY} h={coalH} color="#8BA1C0" label="COAL" pct={100} />
        <Node x={col.steam} y={steamY} h={steamH} color="#fab20b" label="STEAM" pct={data.steam} />
        <Node x={col.useful} y={usefulY} h={usefulH} color="#33b76d" label="USEFUL" pct={data.useful} />
        <Node x={col.prod} y={topPad} h={megH} color="#33b76d" label="MEG" pct={data.meg} />
        <Node x={col.prod} y={topPad + megH + 10} h={degH} color="#1d6fb8" label="DEG" pct={data.deg} />
        <Node x={col.prod} y={topPad + megH + degH + 20} h={tegH} color="#9b5de5" label="TEG" pct={data.teg} />
      </motion.svg>
    </div>
  );
}
